import id from "vee-validate/dist/locale/id";
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";

Validator.localize("id", id);
Vue.use(VeeValidate);

VeeValidate.Validator.extend("valid_password", {
  getMessage: field =>
    `${field} harus mengandung Huruf besar, Huruf kecil, Angka dan Simbol`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])"
    );
    return strongRegex.test(value);
  }
});
